import { render, staticRenderFns } from "./ScaniaNextGenDashboard.vue?vue&type=template&id=5020ebad&"
import script from "./ScaniaNextGenDashboard.vue?vue&type=script&lang=js&"
export * from "./ScaniaNextGenDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports